export default {
  "SeparateSettingContents.Title": "個別詳細設定",
  "SeparateSettingContents.Summary":
    "提供先や提供する情報について個別に設定することができます",
  "SeparateSettingContents.LinkText":
    "ドコモグループ・NTTグループ・その他提携先とは",
  "SeparateSettingContents.Link":
    "https://id-biz.smt.docomo.ne.jp/src/utility/providing_destinations.html",
  "SeparateSettingContents.Caution":
    "{asterisk}サービスのご利用に必要なデータ提供や法令で認められている範囲でお客さまの同意を得る必要がない場合のデータ提供は、変更できません",
  "SeparateSettingContents.BackButtonText1": "上記の内容に同意する",
  "SeparateSettingContents.BackButtonText2": "前のページへ戻る",
}
